import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./TeacherUsersUIHelpers";

const TeacherUsersUIContext = createContext();

export function useTeacherUsersUIContext() {
  return useContext(TeacherUsersUIContext);
}

export const TeacherUsersUIConsumer = TeacherUsersUIContext.Consumer;

export function TeacherUsersUIProvider({ children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams
  };

  return (
    <TeacherUsersUIContext.Provider value={value}>
      {children}
    </TeacherUsersUIContext.Provider>
  );
}